
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";

/* COMPONENTS */
import { Maintenance } from "./components";

/* PAGES */
import {
  Home,
  CatalogPage,
  ProductDetailPage,
  TermsPage,
  PrivacyPage,
  Login,
  Register,
  Profile,
  EditProfile,
  Orders,
  Favorites,
  Addresses,
  ChangePassword,
  Settings,
  Cart,
  Checkout,
  BioLink,
  Blog,
  BlogArticle,
  Stores,
} from "./pages";

import Admin from "./pages/dashboard/Admin";
import ProtectedRoute from "./routes/ProtectedRoute";
import InventoryPage from "./pages/profile/InventoryPage";
import ProductsManager from "./pages/profile/ProductsManager";
import StoresManager from "./pages/profile/StoresManager";
import WorkersManager from "./pages/profile/WorkersManager";
import CartaBarPage from "./pages/public/CartaBarPage";
/* ==========================
   MAINTENANCE MODE
========================== */

const MAINTENANCE_MODE = false;

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {MAINTENANCE_MODE ? (
            /* ==========================
               MAINTENANCE
            ========================== */
            <Route
              path="*"
              element={<Maintenance />}
            />
          ) : (
            <>
              {/* ================= PUBLIC ================= */}

              <Route
                path="/"
                element={<Home />}
              />

              <Route
                path="/bio"
                element={<BioLink />}
              />

              <Route
                path="/sedes"
                element={<Stores />}
              />
              {/* ================= CARTA DEL BAR ================= */}

              <Route
                path="/carta-bar"
                element={<CartaBarPage />}
              />

              {/* ================= BLOG ================= */}

              <Route
                path="/blog"
                element={<Blog />}
              />

              <Route
                path="/blog/:slug"
                element={<BlogArticle />}
              />

              {/* ================= AUTH ================= */}

              <Route
                path="/login"
                element={<Login />}
              />

              <Route
                path="/register"
                element={<Register />}
              />

              {/* ================= LEGAL ================= */}

              <Route
                path="/terms"
                element={<TermsPage />}
              />

              <Route
                path="/privacy"
                element={<PrivacyPage />}
              />

              {/* ================= CATALOG ================= */}

              <Route
                path="/catalog"
                element={<CatalogPage />}
              />

              <Route
                path="/products/:id"
                element={<ProductDetailPage />}
              />

              {/* ================= PROFILE ================= */}

              <Route
                path="/profile"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Profile />
                  </ProtectedRoute>
                }
              />

              {/* ================= PROFILE PAGES ================= */}

              <Route
                path="/profile/edit"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <EditProfile />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/orders"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Orders />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/favorites"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Favorites />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/addresses"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Addresses />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/change-password"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <ChangePassword />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/settings"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Settings />
                  </ProtectedRoute>
                }
              />

              {/* =========================
                  CART
                  PUBLIC
              ========================= */}

              <Route
                path="/cart"
                element={<Cart />}
              />

              <Route
                path="/checkout"
                element={
                  <ProtectedRoute
                    roles={[
                      "cliente",
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <Checkout />
                  </ProtectedRoute>
                }
              />

              {/* ================= ADMIN ================= */}

              <Route
                path="/admin/*"
                element={
                  <ProtectedRoute
                    roles={["admin"]}
                  >
                    <Admin />
                  </ProtectedRoute>
                }
              />
              {/* ================= PRODUCTOS ADMIN ================= */}

                <Route
                  path="/products-admin"
                  element={
                    <ProtectedRoute roles={["admin"]}>
                      <ProductsManager />
                    </ProtectedRoute>
                  }
                />
              {/* ================= TIENDAS ADMIN ================= */}

                <Route
                  path="/stores-admin"
                  element={
                    <ProtectedRoute roles={["admin"]}>
                      <StoresManager />
                    </ProtectedRoute>
                  }
                />
              {/* ================= INVENTORY ================= */}

              <Route
                path="/inventory"
                element={
                  <ProtectedRoute
                    roles={[
                      "trabajador",
                      "admin",
                    ]}
                  >
                    <InventoryPage />
                  </ProtectedRoute>
                }
              />

              {/* ================= WORKER ================= */}

              <Route
                path="/worker"
                element={
                  <ProtectedRoute
                    roles={["trabajador"]}
                  >
                    <div>
                      Worker Panel
                    </div>
                  </ProtectedRoute>
                }
              />
              
                {/* ================= TRABAJADORES ADMIN ================= */}

                <Route
                  path="/workers-admin"
                  element={
                    <ProtectedRoute roles={["admin"]}>
                      <WorkersManager />
                    </ProtectedRoute>
                  }
                />

              {/* ================= REDIRECT ================= */}

              <Route
                path="/dashboard"
                element={
                  <Navigate
                    to="/admin"
                    replace
                  />
                }
              />

              {/* ================= 404 ================= */}

              <Route
                path="*"
                element={
                  <Navigate
                    to="/"
                    replace
                  />
                }
              />
            </>
          )}
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
